module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgAgMAAAAOFJJnAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURUdwTDJv/zBw/zNv/1pr7vgAAAADdFJOUwDfIMe4PcYAAABESURBVBjTY2CgJeBMgDLUb0AZc8sgNFPZ3AaIkhvqEEXqCZwQRXMbmMogSkBssBKQLAOEACuSBQozlQAZYiCFU2joAwAXfQ6Yri0G5wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/xia.png
// module id = 65+O
// module chunks = 1